import { ReviewLogGridHelper } from '@components-clean/core/api-grid/helpers/review-log-grid-helper';
import { ColumnDefinition } from '@interfaces/central-monitoring';

enum ControlsReviewLogColumns {
    Panel = 'panel',
    ChildPanel = 'child_panel',
    TimePeriod = 'time_period',
    YValueParent = 'y_value_parent',
    YValue = 'y_value',
    NumeratorParent = 'numerator_parent',
    DenominatorParent = 'denominator_parent',
}

export class ControlsReviewLogHelper extends ReviewLogGridHelper {
    controlsReviewLogsColumnsWidth: Map<string | null | undefined, number> = new Map([
        [ControlsReviewLogColumns.ChildPanel, 545],
        [ControlsReviewLogColumns.YValueParent, 540],
        [ControlsReviewLogColumns.YValue, 180],
        [ControlsReviewLogColumns.NumeratorParent, 360],
        [ControlsReviewLogColumns.DenominatorParent, 360],
    ]);

    getColumnWidth(columnType: ColumnDefinition) {
        let width = this.controlsReviewLogsColumnsWidth.get(
            this._isChild && columnType.dataField === ControlsReviewLogColumns.Panel
                ? ControlsReviewLogColumns.ChildPanel
                : columnType.dataField,
        );
        if (width) return width;

        width = super.getColumnWidth(columnType);
        return width;
    }
}
